import { LogisticStatus } from 'models/logistic'

export const LOGISTIC_STATUS_TEXT: Record<LogisticStatus, string> = {
  [LogisticStatus.new]: 'Новый',
  [LogisticStatus.ready_processing]: 'Готов к обработке',
  [LogisticStatus.in_process]: 'На доставке',
  [LogisticStatus.waiting]: 'В ожидании',
  [LogisticStatus.for_delivery]: 'Выдана на доставку',
  [LogisticStatus.given]: 'Доставлен',
  [LogisticStatus.denied]: 'Возврат карты',
  [LogisticStatus.accepted]: 'Документ принят',
  [LogisticStatus.no_accepted]: 'Документ не принят',
  [LogisticStatus.transferred]: 'Передан в подразделение',
  [LogisticStatus.repeat]: 'Повторная доставка',
}
